import './form-tier-level.scss';

import { TierLevelFormSchema } from "@factory/form/form.rule";
import CheckboxControl from "@shared/ui/hook-form/checkbox-control/checkbox-control";
import InputControl from "@shared/ui/hook-form/input-control/input-control";
import InputDateControl from "@shared/ui/hook-form/input-date-control/input-date-control";
import InputDigitControl from "@shared/ui/hook-form/input-digit-control/input-digit-control";
import { useFormContext } from "react-hook-form";

type InputFormSchema = TierLevelFormSchema;
export function FormTierLevel() {
  const { control } = useFormContext<TierLevelFormSchema>();
  return (
    <div id="FormTierLevel" className="tier-level">
      <InputControl<InputFormSchema>
        control={control}
        name="name"
        label="Name"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter name"
      />
      <InputDigitControl<InputFormSchema>
        control={control}
        name="level"
        label="Level"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter level"
      />
      <InputDigitControl<InputFormSchema>
        control={control}
        name="minAmount"
        label="Min Amount"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter minAmount"
      />
      <InputDigitControl<InputFormSchema>
        control={control}
        name="maxAmount"
        label="Max Amount"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter maxAmount"
      />
      <InputControl<InputFormSchema>
        control={control}
        name="description"
        label="Description"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter description"
      />
    </div>
  );
}

export default FormTierLevel;
